import ListVirtualEmailTable from '../../components/ListVirtualEmails/ListVirtualEmailTable';

const Forwarding = () => {
  return (
    <ListVirtualEmailTable />
  );
}

export default Forwarding;